import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-hot-toast"
import { Cog6ToothIcon, CalculatorIcon } from "@heroicons/react/24/outline"
import DashboardHeader from "../../../components/dashboard/dashboardHeader"
import { InventoryStats } from "../../../components/dashboard/inventory/inventory-stats"
import PMLinkCard from "../../../components/utils/PMLinkCard"
import InventoryStorageModal from "../../../components/dashboard/inventory/InventoryStorageModal"
import InventoryCountsStacklist from "../../../components/dashboard/inventory/counts/inventory-counts-stacklist"
import InventoryCountModal from "../../../components/dashboard/inventory/counts/Inventory-count-modal"
import { getCountsAsync } from "../../../slices/inventory/count"

export const InventoryList = () => {
  const dispatch = useDispatch()
  const [newStorageModalOpen, setNewStorageModalOpen] = useState(false)
  const [newCountModalOpen, setNewCountModalOpen] = useState(false)

  const countsState = useSelector((store) => store.inventory_counts)
  const { data: counts, isLoading: countsLoading, error: countsError, errors: countsErrors } = countsState

  useEffect(() => {
    dispatch(getCountsAsync())
  }, [dispatch])

  const rightSideActions = [
    {
      label: 'New Storage',
      description: 'Create a new Inventory Storage',
      path: '',
      action: () => setNewStorageModalOpen(true),
      icon: Cog6ToothIcon,
      iconForeground: 'text-teal-700',
      iconBackground: 'bg-teal-50',
    },
    {
      label: 'New Inventory Count',
      description: 'Create a new Inventory Count',
      path: '',
      action: () => setNewCountModalOpen(true),
      icon: Cog6ToothIcon,
      iconForeground: 'text-teal-700',
      iconBackground: 'bg-teal-50',
    },
    {
      label: 'Counter',
      description: 'Count products with the Counter',
      path: '',
      action: () => toast.error('This function is not available'),
      icon: CalculatorIcon,
      iconForeground: 'text-teal-700',
      iconBackground: 'bg-teal-50',
    }
  ]

  return (
    <>
      <DashboardHeader
        title="Inventory Overview"
        subtitle="Manage your inventory, storages, and counts"
      />
      <div className="mx-auto max-w-7xl px-3 sm:px-6 lg:px-8">
        <div className="mt-8 grid grid-cols-1 gap-6">
          <div className="max-sm:hidden">
            <InventoryStats />
          </div>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            <div className="rounded-lg bg-white shadow-sm ring-1 ring-inset ring-gray-200">
              <PMLinkCard actions={rightSideActions} />
            </div>
            <InventoryCountsStacklist
              label="Siste tellinger"
              items={counts || []}
              isLoading={countsLoading}
              error={countsError}
              errors={countsErrors}
              onCreateNew={() => setNewCountModalOpen(true)}
            />
          </div>
        </div>
      </div>

      <InventoryStorageModal
        onClose={() => setNewStorageModalOpen(false)}
        open={newStorageModalOpen}
        itemId={0}
      />
      <InventoryCountModal
        onClose={(shouldRefresh) => {
          setNewCountModalOpen(false)
          if (shouldRefresh) {
            dispatch(getCountsAsync())
          }
        }}
        open={newCountModalOpen}
        itemId={0}
      />
    </>
  )
}
